import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import List from './list/List';

import {Divider, Stack, Typography} from 'views/components';

import {Translate} from 'views/module';

import backend from 'utils/backend';
import simplifyQuestions from 'utils/user_bio/simplify_questions';

const CaregiverList = (props) => {
  const {
    clientRn,
    statusProgressWrap: progressWrap,
  } = props;
  const [data, setData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setIsLoading(true);
    progressWrap(async () => {
      try {
        const clientDetailResult = await backend.client.getClient(clientRn);

        const caregiverRoster = clientDetailResult.clientDetail.caregivers;
        const clientCaregiversResult = await Promise.all(
            Object.entries(caregiverRoster).map(async ([caregiverRn, caregiverData]) => {
              const additionalCaregiverData = await backend.caregiver.getCaregiverForClient(caregiverRn);

              if (!doesContainMinData(additionalCaregiverData)) {
                return null;
              } else {
                return {
                  ...caregiverData,
                  ...additionalCaregiverData,
                };
              }
            }),
        );
        setData(clientCaregiversResult.filter(Boolean));
      } finally {
        setIsLoading(false);
      }
    });
  }, []);

  const doesContainMinData = (caregiverData) => {
    const questionsBio = caregiverData?.caregiverBio?.questions || {};
    const questions = simplifyQuestions(questionsBio);
    const required = [
      'firstName',
      'lastName',
      'city',
      'province',
    ];
    return required.every((k) => questions?.[k] && (questions?.['personalBio'] || questions?.['caregiverMotivation']));
  };

  return (
    <Stack spacing={1}>
      <Stack
        spacing={1}
        sx={{
          py: {xs: 1, sm: 2},
        }}
      >
        <Typography
          sx={{
            fontWeight: 300,
            fontStyle: 'light',
            fontSize: '2.0rem',
            lineHeight: '120%',
            letterSpacing: '-2%',
          }}
          align='left'
        >
          <Translate expression={'caregiverList.main.Title'} />
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            fontStyle: 'normal',
            fontSize: '1.0rem',
            lineHeight: '150%',
            letterSpacing: '0%',
          }}
          align='left'
        >
          <Translate expression={'caregiverList.main.Subtitle'} />
        </Typography>
      </Stack>
      <Divider/>
      <List
        data={data}
        isLoading={isLoading}
      />
    </Stack>
  );
};

CaregiverList.propTypes = {
  clientRn: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  clientRn: state.user.clientRn,
});

export default connect(mapStateToProps, dispatch)(React.memo(CaregiverList));
